import { useEffect, useRef, useState } from 'react';

export default function useClientModalDrop({ enabled, cardRef, onFiles }) {
  const callback = useRef(onFiles);
  callback.current = onFiles;
  const [active, setActive] = useState(false);
  useEffect(() => {
    setActive(false);
    if (!enabled) return;
    const inside = target => target instanceof Node && cardRef.current?.contains(target);
    const isFiles = e => Array.from(e.dataTransfer?.types || []).includes('Files') || !!e.dataTransfer?.files?.length;
    const reset = () => setActive(false);
    const over = e => {
      if (!isFiles(e)) return;
      const within = inside(e.target);
      setActive(within);
      e.preventDefault();
      e.dataTransfer.dropEffect = within ? 'copy' : 'none';
    };
    const drop = e => {
      reset();
      if (!isFiles(e)) return;
      e.preventDefault();
      if (!inside(e.target)) return;
      e.stopPropagation();
      const files = Array.from(e.dataTransfer.files || []);
      if (files.length) callback.current?.(files);
    };
    const leave = e => { if (!e.relatedTarget) reset(); };
    document.addEventListener('dragover', over, true);
    document.addEventListener('drop', drop, true);
    document.addEventListener('dragleave', leave, true);
    document.addEventListener('dragend', reset, true);
    window.addEventListener('blur', reset);
    return () => {
      document.removeEventListener('dragover', over, true);
      document.removeEventListener('drop', drop, true);
      document.removeEventListener('dragleave', leave, true);
      document.removeEventListener('dragend', reset, true);
      window.removeEventListener('blur', reset);
    };
  }, [enabled, cardRef]);
  return active;
}
